import { useEffect } from "react";
import ReactPixel from "react-facebook-pixel";

const useAnalytics = () => {
  const pixelOptions = {
    autoConfig: true,
    debug: false,
  };

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      ReactPixel.init("949386926786086", pixelOptions);
      ReactPixel.pageView();
    }
  }, []);
};

export default useAnalytics;
